import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '@tectonics/commons/customer-form/get-phone-number-normalizer';
import { normalizeChileanDocument } from '@tectonics/prs/chile';

const CHILE: Country = {
  code: 'cl',
  customerForm: {
    documentNormalizer: normalizeChileanDocument,
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default CHILE;
